import { Image } from 'foundations-components/transitional/components/Image';
// @ts-expect-error bender url not supported yet
import meetingPopupPreviewImage from 'bender-url!web-interactives-components/img/meetingPopupPreview.png';
import { jsx as _jsx } from "react/jsx-runtime";
const MeetingPopupDemoImage = props => {
  return /*#__PURE__*/_jsx(Image, Object.assign({
    src: meetingPopupPreviewImage
  }, props));
};
export default MeetingPopupDemoImage;